@if (canSwitch()) {
  <h1 class="current">
    <button
      #trigger
      type="button"
      class="trigger"
      aria-haspopup="listbox"
      [attr.aria-expanded]="open()"
      [attr.aria-controls]="open() ? listId : null"
      [title]="(companyName() || 'Empresa') + ' (trocar de empresa)'"
      (click)="toggle()"
      (keydown)="onTriggerKeydown($event)">
      <span class="trigger__name">{{ companyName() || 'Empresa' }}</span>
      <i
        class="pi pi-chevron-down trigger__chevron"
        [class.trigger__chevron--open]="open()"
        aria-hidden="true"></i>
    </button>
  </h1>

  @if (open()) {
    <div class="popover" role="dialog" aria-label="Trocar de empresa">
      <div class="search">
        <i class="pi pi-search search__icon" aria-hidden="true"></i>
        <input
          #searchInput
          type="text"
          class="search__input"
          role="combobox"
          aria-autocomplete="list"
          aria-label="Buscar empresa por nome ou CNPJ"
          placeholder="Buscar por nome ou CNPJ"
          autocomplete="off"
          [attr.aria-expanded]="true"
          [attr.aria-controls]="listId"
          [attr.aria-activedescendant]="activeIndex() >= 0 ? optionId(activeIndex()) : null"
          [value]="term()"
          (input)="onTermInput($any($event.target).value)"
          (keydown)="onSearchKeydown($event)" />
        @if (term()) {
          <button
            type="button"
            class="search__clear"
            title="Limpar a busca"
            aria-label="Limpar a busca"
            (click)="clearTerm()">
            <i class="pi pi-times" aria-hidden="true"></i>
          </button>
        }
      </div>

      <ul #list class="options" role="listbox" [id]="listId" aria-label="Empresas">
        @if (loading() && !items().length) {
          @for (row of skeletonRows; track row) {
            <li class="skel" aria-hidden="true">
              <span class="skel__line" [style.width.%]="68 - row * 9"></span>
              <span class="skel__line skel__line--sub"></span>
            </li>
          }
        } @else if (failed()) {
          <li class="note">
            <span>Não foi possível carregar as empresas.</span>
            <button type="button" class="note__action" (click)="retry()">Tentar de novo</button>
          </li>
        } @else if (!items().length) {
          <li class="note">
            @if (term().trim()) {
              Nenhuma empresa encontrada para "{{ term().trim() }}".
            } @else {
              Nenhuma empresa no seu escopo.
            }
          </li>
        } @else {
          @for (item of items(); track item.companyId; let i = $index) {
            <li
              class="option"
              role="option"
              [id]="optionId(i)"
              [class.option--active]="i === activeIndex()"
              [class.option--current]="item.companyId === companyId()"
              [class.option--stale]="loading()"
              [attr.aria-selected]="item.companyId === companyId()"
              (pointermove)="activeIndex.set(i)"
              (click)="select(item)">
              <span class="option__check" aria-hidden="true">
                @if (item.companyId === companyId()) {
                  <i class="pi pi-check"></i>
                }
              </span>
              <span class="option__text">
                <span class="option__name" [title]="item.companyName">{{ item.companyName }}</span>
                <span class="option__cnpj">{{
                  item.cnpj ? formatCnpj(item.cnpj) : 'CNPJ não informado'
                }}</span>
              </span>
              @if (item.status) {
                <app-charter-status-badge
                  class="option__badge"
                  [status]="item.status"
                  [pendingReviewCount]="item.pendingReviewCount" />
              }
            </li>
          }
        }
      </ul>

      <div class="foot">
        <span class="foot__count">
          @if (!failed() && total() > items().length) {
            {{ items().length }} de {{ total() }}. Refine a busca para ver as outras.
          }
        </span>
        <button
          type="button"
          class="foot__link"
          title="Volta para a lista Societário, sem empresa selecionada"
          (click)="clearSelection()">
          Limpar seleção
        </button>
      </div>
    </div>
  }
} @else {
  <h1 class="current current--static" [title]="companyName() ?? ''">
    {{ companyName() || 'Empresa' }}
  </h1>
}
